import React, { Component } from "react";
import requestAnimationFrameExact from "./requestAnimationFrameExact";
// @ts-ignore
import PropTypes from "prop-types";

class TransitionWhenHeightChange extends Component {
  constructor(props: any) {
    super(props);
    this.state = {
      style: { height: props.height },
      placeholderHeight: null,
    };

    // @ts-ignore
    this.el = { current: null };
  }

  UNSAFE_componentWillReceiveProps(nextP: any) {
    // @ts-ignore
    if (nextP.height !== this.props.height) {
      // fold
      if (nextP.height) {
        this.setState(
          {
            style: {
              // @ts-ignore
              height: this.el.current.clientHeight,
            },
          },
          this.afterCollapse
        );
      }
      // open
      else {
        this.setState(
          {
            // @ts-ignore
            placeholderHeight: this.el.current.clientHeight,
            style: {
              height: null,
            },
          },
          this.afterExpand
        );
      }
    }
  }
  afterExpand() {
    requestAnimationFrameExact(() => {
      // @ts-ignore
      const height = this.el.current.clientHeight;
      this.setState(
        {
          placeholderHeight: null,
          style: {
            // @ts-ignore
            height: this.state.placeholderHeight,
          },
        },
        () => {
          requestAnimationFrameExact(() => {
            this.setState({
              style: {
                height: height,
                // @ts-ignore
                transitionDuration: this.props.duration + "ms",
              },
            });
          });
        }
      );
    });
  }
  afterCollapse() {
    requestAnimationFrameExact(() => {
      this.setState({
        style: {
          // @ts-ignore
          height: this.props.height,
        },
      });
    });
  }
  render() {
    const state = this.state;
    return (
      <div
        style={{
          // @ts-ignore
          height: state.placeholderHeight,
          overflowY: "auto",
          borderRadius: "4px",
          border: "1px solid #e2e2e2",
        }}
      >
        {/* @ts-ignore */}
        <div
          ref={(this as any).el}
          className="autoHeightChangeContainer"
          style={Object.assign(
            {
              transitionProperty: "height",
              // @ts-ignore
              overflow: this.props.overflow,
              // @ts-ignore
              transitionDuration: this.props.duration + "ms",
              // @ts-ignore
              transitionTimingFunction: this.props.timeFunction,
            },
            // @ts-ignore
            this.state.style
          )}
        >
          {/* @ts-ignore */}
          {this.props.children}
        </div>
      </div>
    );
  }
}

// @ts-ignore
TransitionWhenHeightChange.defaultProps = {
  duration: 300,
  timeFunction: "ease",
  overflow: "hidden",
};

TransitionWhenHeightChange.propTypes = {
  duration: PropTypes.number,
  timeFunction: PropTypes.string,
  overflow: PropTypes.string,
};

export default TransitionWhenHeightChange;
